import {
    fetchSellerCoverageReport,
    fetchSellerCoverageItems,
    FetchSellerCoveragePayload,
    FetchSellerCoverageItemsPayload,
} from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const SellerCoverageKeys = {
    all: ['sellerCoverageReport'] as const,
    list: (payload: FetchSellerCoveragePayload) => [...SellerCoverageKeys.all, payload] as const,
    items: (payload: FetchSellerCoverageItemsPayload) => [...SellerCoverageKeys.all, 'items', payload] as const,
}

export const useSellerCoverageReportQuery = (
    payload: FetchSellerCoveragePayload = {},
    options?: { enabled?: boolean }
) => {
    return useQuery({
        queryFn: () => fetchSellerCoverageReport(payload),
        queryKey: SellerCoverageKeys.list(payload),
        enabled: options?.enabled ?? true,
    })
}

export const useSellerCoverageItemsQuery = (payload: FetchSellerCoverageItemsPayload | null) => {
    return useQuery({
        queryFn: () => fetchSellerCoverageItems(payload!),
        queryKey: SellerCoverageKeys.items(payload!),
        enabled: Boolean(payload && payload.SK_PESQUISA && payload.SK_VENDEDOR),
    })
}

